import { useSettings } from "../lib/settings";

const gmId = (file) => (String(file || "").match(/gamemonetize\.(?:co|com)\/([a-z0-9]+)/i) || [])[1];

// Same iframe GameMonetize's video.js builds, without its jQuery dependency
export function Walkthrough({ game }) {
  const s = useSettings();
  const id = gmId(game.file);
  if (!id || s.walkthrough_enabled === false) return null;
  const domain = window.location.hostname.replace(/^www\./, "");
  const q = new URLSearchParams({
    domain,
    gameid: id,
    game: game.title,
    getads: s.walkthrough_ads === true ? "true" : "false",
    color: "#0f75a5",
  });
  return (
    <div id="game-bottom" className="bgs fn-clear gg-walkthrough" data-testid="game-walkthrough">
      <h2>Video Tutorial di come giocare a {game.title}</h2>
      <div id="gamemonetize-video">
        <iframe
          id="gamemonetize-walkthrough"
          title={`Video soluzione ${game.title}`}
          src={`https://gamemonetize.video/index.php?${q.toString()}`}
          scrolling="no"
          frameBorder="0"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
}
